import styled, { css } from 'styled-components';

import {
  breakpoints,
  ProductSliderPlaceholder,
  theme,
} from '@notino/react-styleguide';

export const Title = styled.div`
  ${theme.typography.titleLarge}
  text-align: center;
`;

export const StyledLoadingPlaceholder = styled(ProductSliderPlaceholder)<{
  center: boolean;
}>`
  margin: 1.25rem 0 2.25rem;

  @media (min-width: ${breakpoints.md}) {
    margin: 2.25rem 0 2rem;
  }

  ${({ center }) =>
    center &&
    css`
      justify-content: center;
    `}
`;

export const SliderWrapper = styled.div<{ centerSlider: boolean }>`
  margin: 1.25rem 0 0.25rem;

  [data-testid='phone-slider'] {
    padding: 0 1.25rem 2rem;

    ${({ centerSlider }) =>
      centerSlider &&
      css`
        justify-content: center;
      `}
  }

  @media (min-width: ${breakpoints.md}) {
    margin: 2.25rem 0 2rem;

    ${({ centerSlider }) =>
      centerSlider &&
      css`
        [data-testid='desktop-slider'] > div {
          justify-content: center;
        }
      `}
  }
`;

export const OtherVariantsWrapper = styled.div`
  display: block;
  color: ${theme.color.text.primary};
  ${theme.typography.labelRegular};
  margin-top: 1.5rem;
`;
